import { Injectable } from '@angular/core';
import numeral from 'numeral';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { UserLocaleService } from '@monsido/core/locale/services/locale.service';

@Injectable({
    providedIn: 'root',
})

export class LocaleRunService {
    constructor (private monEventService: MonEventService, private userLocalService: UserLocaleService) { }

    initializeApp () {
        this.monEventService.addListener('afterLoadUser', (payload: any) => {
            numeral.locale(this.userLocalService.getNumeralValue(payload.locale));
        });
    }
}
